import { ArrowUpRight } from "lucide-react";
import Artwork from "./Artwork";
import { Reveal, Eyebrow } from "./Reveal";
import { CONTENT } from "@/content";

const TILES = ["beam", "ember", "horizon", "veil"];

export default function InstagramSection() {
  return (
    <section data-testid="instagram-section" className="relative py-28 md:py-40 px-6 md:px-16 border-t border-white/5 overflow-hidden">
      <div className="max-w-[1600px] mx-auto text-center">
        <Reveal>
          <Eyebrow className="justify-center">INSTAGRAM</Eyebrow>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-extrabold uppercase tracking-tight leading-[0.9] text-5xl sm:text-7xl lg:text-8xl text-[#f5f3ef] mt-6">
            ENTER THE WORLD
            <br />
            <span className="text-stroke">OF TONE</span>
          </h2>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-14 flex justify-center gap-3 md:gap-5">
            {TILES.map((v, i) => (
              <a
                key={v}
                data-testid={`instagram-tile-${i}`}
                href={CONTENT.instagram.url}
                target="_blank"
                rel="noopener noreferrer"
                className="group block w-1/4 max-w-[180px]"
              >
                <Artwork
                  variant={v}
                  image={CONTENT.instagramImages?.[i] || null}
                  alt={`Instagram ${CONTENT.instagram.handle}`}
                  className="w-full aspect-square opacity-70 group-hover:opacity-100 transition-all duration-700 group-hover:scale-[1.03]"
                />
              </a>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.3}>
          <a
            data-testid="instagram-cta"
            href={CONTENT.instagram.url}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-14 inline-flex items-center gap-3 px-10 py-4 border border-white/15 font-mono2 text-[11px] tracking-[0.35em] text-[#f5f3ef] hover:border-[#38bdf8]/70 hover:text-[#70c7fa] hover:shadow-[0_0_32px_rgba(56,189,248,0.2)] transition-all duration-500"
          >
            FOLLOW {CONTENT.instagram.handle} <ArrowUpRight className="w-4 h-4" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}
